/**
 * Shared role-label mapping for the User Administration console.
 *
 * FIELD-001C · The visible label for the internal role identifier
 * `installer` is "Field User". The internal identifier itself is
 * preserved everywhere (auth, permissions, API contracts, engineer
 * mappings). "Account role" governs application access; a field
 * user's *resource type* (Electrician, Scaffolder, etc.) is a
 * separate attribute managed in Field Team Management.
 */
export const ROLE_LABELS = {
    customer:   "Customer",
    installer:  "Field User",
    operations: "Operations",
    sales:      "Sales",
};

/** Options exposed by the "Create / Edit user" account-role dropdown. */
export const ROLE_OPTIONS = [
    { value: "customer",   label: "Customer" },
    { value: "installer",  label: "Field User" },
    { value: "sales",      label: "Sales" },
    { value: "operations", label: "Operations" },
];

export function roleLabel(role) {
    return ROLE_LABELS[role] || role || "—";
}
